import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24BlocksG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillOpacity: 0.38,
      fillRule: "evenodd",
      d: "m7.347 5.867-.135.008a1.08 1.08 0 0 0-.945 1.07l-.001 1.948-1.13.002a1.08 1.08 0 0 0-1.078 1.078v7.386c0 .588.478 1.066 1.067 1.066h16.241c.597 0 1.079-.484 1.079-1.08V9.961l-.009-.133a1.07 1.07 0 0 0-1.058-.933l-1.144-.002.001-1.948a1.08 1.08 0 0 0-1.078-1.078h-3.674l-.134.008a1.066 1.066 0 0 0-.932 1.058l-.002 1.96h-2.329l.001-1.948c0-.596-.483-1.078-1.078-1.078zm11.287 1.598.001 2.23.01.13a.8.8 0 0 0 .79.67l1.408-.002v6.331H5.657v-6.33h1.41l.13-.01a.8.8 0 0 0 .67-.79l-.001-2.229h2.62l.001 2.23a.8.8 0 0 0 .8.8h3.93l.13-.01a.8.8 0 0 0 .67-.79l-.002-2.23z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24BlocksG$1 = Svg24BlocksG;

export { Svg24BlocksG$1 as default };
